import { c as _c } from "react/compiler-runtime";
import { IconLoader } from "@tabler/icons-react";
export const Spinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconLoader className="animate-spin" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};